module.exports = __webpack_public_path__ + "img/widget-novo-c.e9f54f3b.png";